module.exports = __webpack_public_path__ + "static/img/HORACIO_QUIROZ.75b8ac3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/HORACIO_QUIROZ.jpg
// module id = XCQw
// module chunks = 1